import React, { Component } from "react";
import ExperienceCard from "./ExperienceCard";
import "./ExperienceAccordion.css";
import {ThemeProps} from "../../components/styles/themeprops";

type State = {
  redirect: boolean,
}
type section = {
  title: string,
  index:number,
  experiences:Exp[],
}
type Project = {name: string,desc:string,stack:string}
type Exp = {
  title: string,
  company: string,
  company_url: string,
  logo_path:string,
  duration: string,
  location: string,
  color: string,
  projects: Project[],
}
type Props = {theme: ThemeProps,sections: section[]}
class ExperienceAccordion extends Component<Props,State> {
  render() {
    const theme = this.props.theme;
    return (
      <div className="experience-accord">
        <div className="acco">
          {this.props.sections.map((section) => {
            return (
              <div className="acco-panel" title={section["title"]} key={section["title"]}>
              	<input type="checkbox" id={'accochek'+section.index} className="acco-check"/>
        				<label className="acco-label" htmlFor={'accochek'+section.index}>{section["title"]}</label>
        				<div className="acco-content">
                {section["experiences"].map((experience) => {
                  return (
                    <ExperienceCard experience={experience} theme={theme} />
                  );
                })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ExperienceAccordion;
